import "./style/index.scss";
import dayjs from "dayjs";
import { PlusCircleOutlined, PrinterOutlined, RedoOutlined } from "@ant-design/icons";
import { Button, Col, Form, Row, Select, Image, Tag, Modal, Tabs, Tooltip, Flex } from "antd";
import Table, { ColumnsType } from "antd/es/table";
import { useEffect, useRef, useState } from "react";
import { setIdEmpresaPermissao, setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { currencyBRL, formatNumber } from "../../util/dinheiroBRAuxiliar";
import { formatCPFCNPJ } from "../../util/formats";
import { useAppSelector, useAppDispatch } from "../../util/hooks";
import { buscarImportacaoVendaConsignatario, importarVendaConsignatario, processarImportacaoVendaConsignatario } from "../../services/importacaoVendaConsignatarioService";
import { buscarEmpresa } from "../../services/empresaService";
import {
  resetImportacao,
  setBuscaImportacaoVendaConsignatario,
  setModalConfirmarImportacaoVendaConsignatario,
} from "../../redux/slices/importacaoVendaConsignatario/importacaoVendaConsignatarioSlice";
import { listarSorteio } from "../../services/sorteioService";
import TabPane from "antd/es/tabs/TabPane";
import React from "react";
import { DetalhesImportacaoVendaConsignatarioDtoModel } from "../../models/importacaoVendaConsignatario/detalhesImportacaoVendaConsignatarioDtoModel";
import { useReactToPrint } from "react-to-print";
import { BuscarImportacaoVendaConsignatarioModel } from "../../models/importacaoVendaConsignatario/buscarImportacaoVendaConsignatarioModel";
import { EmpresaModel } from "../../models/empresa/empresaModel";
import TableComponent from "../../components/table/tableComponent";
import MensagemModal from "../../components/modal/mensagem";
import { ButtonComponent } from "../../components/button/cadastrar";

dayjs.locale("pt-br");

const ImportacaoVendaConsignatario = () => {
  //estados globais
  const importacaoVendaConsignatarioState = useAppSelector((state) => state.importacaoVendaConsignatario);
  const empresaState = useAppSelector((state) => state.empresa);
  const sorteioState = useAppSelector((state) => state.sorteio);
  const persistedState = useAppSelector((state) => state.persisted);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();
  const [abaAtiva, setAbaAtiva] = useState("1");

  const relatorioImportacao = useRef<HTMLDivElement>(null);

  useEffect(() => {
    dispatch(setTitle("IMPORTAÇÃO DAS VENDAS DOS CONSIGNATÁRIOS"));
    dispatch(buscarEmpresa(empresaState.busca));
    if (persistedState.user.empresa !== null) {
      onChangeEmpresa(persistedState.user.empresa.idEmpresa);
    }
  }, []);

  const onChangeEmpresa = (value: number) => {
    dispatch(setIdEmpresaPermissao(value));

    setAbaAtiva("1");
    dispatch(resetImportacao());

    let busca: BuscarImportacaoVendaConsignatarioModel = { ...importacaoVendaConsignatarioState.busca, idEmpresa: value };

    dispatch(setBuscaImportacaoVendaConsignatario(busca));
    dispatch(listarSorteio(value.toString()));
  };

  const onChangeSorteio = (value: number) => {
    let busca: BuscarImportacaoVendaConsignatarioModel = { ...importacaoVendaConsignatarioState.busca, idSorteio: value };

    dispatch(setBuscaImportacaoVendaConsignatario(busca));
    dispatch(buscarImportacaoVendaConsignatario(busca));
  };

  const importarDados = () => {
    dispatch(importarVendaConsignatario({ value: importacaoVendaConsignatarioState.busca, busca: importacaoVendaConsignatarioState.busca }));
  };

  const goConfirmarProcessar = () => {
    dispatch(setModalConfirmarImportacaoVendaConsignatario(true));
  };

  const closeModalProcessar = () => {
    dispatch(setModalConfirmarImportacaoVendaConsignatario(false));
  };

  const atualizar = () => {
    dispatch(buscarImportacaoVendaConsignatario(importacaoVendaConsignatarioState.busca));
  };

  const columns: ColumnsType<DetalhesImportacaoVendaConsignatarioDtoModel> = [
    {
      title: "CONSIGNATÁRIO",
      dataIndex: "consignatario",
      sorter: (a, b) => a.consignatario.localeCompare(b.consignatario),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "CPF/CNPJ",
      dataIndex: "cpfCnpjConsignatario",
      render: (_, record) => formatCPFCNPJ(record.cpfCnpjConsignatario),
    },
    {
      title: "QUANTIDADE",
      dataIndex: "quantidadeVenda",
      align: "right",
      render: (_, record) => formatNumber(record.quantidadeVenda),
    },
    {
      title: "TICKET",
      dataIndex: "valorTicket",
      align: "right",
      render: (_, record) => currencyBRL(record.valorTicket),
    },
    {
      title: "VALOR TOTAL",
      dataIndex: "valorTotal",
      align: "right",
      render: (_, record) => currencyBRL(record.valorTotal),
    },
    {
      title: "QTD. VENDA FÍSICA",
      dataIndex: "vendaFisica_QuantidadeVendida",
      align: "right",
      render: (_, record) => formatNumber(record.vendaFisica_QuantidadeVendida),
    },
    {
      title: "VALOR VENDA FÍSICA",
      dataIndex: "vendaFisica_ValorVenda",
      align: "right",
      render: (_, record) => currencyBRL(record.vendaFisica_ValorVenda),
    },
    {
      title: "QTD. VENDA INTERNET",
      dataIndex: "vendaInternet_QuantidadeVendida",
      align: "right",
      render: (_, record) => formatNumber(record.vendaInternet_QuantidadeVendida),
    },
    {
      title: "VALOR VENDA INTERNET",
      dataIndex: "vendaInternet_ValorVenda",
      align: "right",
      render: (_, record) => currencyBRL(record.vendaInternet_ValorVenda),
    },
  ];

  const TabelaListagem = () => {
    // Use reduce for better readability and accuracy
    return (
      <TableComponent
        columns={columns}
        data={importacaoVendaConsignatarioState.list}
        loading={importacaoVendaConsignatarioState.loading}
        pagination={false}
        tableProps={{
          summary: (pageData: any) => {
            const totals = pageData.reduce(
              (
                acc: {
                  quantidadeVenda: number;
                  valorTotal: number;
                  vendaFisica_QuantidadeVendida: number;
                  vendaFisica_ValorVenda: number;
                  vendaInternet_QuantidadeVendida: number;
                  vendaInternet_ValorVenda: number;
                },
                curr: any
              ) => ({
                quantidadeVenda: acc.quantidadeVenda + (curr.quantidadeVenda || 0),
                valorTotal: acc.valorTotal + (curr.valorTotal || 0),
                vendaFisica_QuantidadeVendida: acc.vendaFisica_QuantidadeVendida + (curr.vendaFisica_QuantidadeVendida || 0),
                vendaFisica_ValorVenda: acc.vendaFisica_ValorVenda + (curr.vendaFisica_ValorVenda || 0),
                vendaInternet_QuantidadeVendida: acc.vendaInternet_QuantidadeVendida + (curr.vendaInternet_QuantidadeVendida || 0),
                vendaInternet_ValorVenda: acc.vendaInternet_ValorVenda + (curr.vendaInternet_ValorVenda || 0),
              }),
              {
                quantidadeVenda: 0,
                valorTotal: 0,
                vendaFisica_QuantidadeVendida: 0,
                vendaFisica_ValorVenda: 0,
                vendaInternet_QuantidadeVendida: 0,
                vendaInternet_ValorVenda: 0,
              }
            );
            return (
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={2}>
                  Total
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} className="totais">
                  <span>{formatNumber(totals.quantidadeVenda)}</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3}></Table.Summary.Cell>
                <Table.Summary.Cell index={4} className="totais">
                  <span>{currencyBRL(totals.valorTotal)}</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={5} className="totais">
                  <span>{formatNumber(totals.vendaFisica_QuantidadeVendida)}</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={6} className="totais">
                  <span>{currencyBRL(totals.vendaFisica_ValorVenda)}</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={7} className="totais">
                  <span>{formatNumber(totals.vendaInternet_QuantidadeVendida)}</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={8} className="totais">
                  <span>{currencyBRL(totals.vendaInternet_ValorVenda)}</span>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            );
          },
        }}
      />
    );
  };

  let totalQuantidadeVenda = 0;
  let totalValorTotal = 0;
  let totalVendaFisicaQuantidadeVendida = 0;
  let totalVendaFisicaValorVenda = 0;
  let totalVendaInternetQuantidadeVendida = 0;
  let totalVendaInternetValorVenda = 0;

  // Iterar sobre os dados de importação
  importacaoVendaConsignatarioState.list.forEach((item: DetalhesImportacaoVendaConsignatarioDtoModel) => {
    totalQuantidadeVenda += item.quantidadeVenda;
    totalValorTotal += item.valorTotal;
    totalVendaFisicaQuantidadeVendida += item.vendaFisica_QuantidadeVendida;
    totalVendaFisicaValorVenda += item.vendaFisica_ValorVenda;
    totalVendaInternetQuantidadeVendida += item.vendaInternet_QuantidadeVendida;
    totalVendaInternetValorVenda += item.vendaInternet_ValorVenda;
  });

  const handlePrint = useReactToPrint({
    content: () => relatorioImportacao.current,
  });

  const RelatorioHtml = React.forwardRef<HTMLDivElement>((_props, ref) => {
    return (
      <div ref={ref} className="relatorios-html-format">
        <div className="rel-cabecalho">
          <div className="rel-titulo">
            <h2>Importação das vendas dos consignatários</h2>
            <p>Gerado em {dayjs().format("DD/MM/YYYY [às] HH:mm")}</p>
          </div>
          <hr />
          <p>
            Empresa: {importacaoVendaConsignatarioState.list[0].empresa} , Data do sorteio: {dayjs(importacaoVendaConsignatarioState.list[0].dataSorteio).format("DD/MM/YYYY")}
          </p>
        </div>
        <div className="rel-detalhes">
          <table className="tb-dados">
            <thead>
              <tr className="header-table">
                <th className="ht-left">Consignatário</th>
                <th className="ht-left">CPF/CNPJ</th>
                <th className="ht-center">Quantidade</th>
                <th className="ht-right">Ticket</th>
                <th className="ht-right">Valor Total</th>
                <th className="ht-right">Qtd Venda Física</th>
                <th className="ht-right">Valor Venda Física</th>
                <th className="ht-right">Qtd Venda Internet</th>
                <th className="ht-right">Valor Venda Internet</th>
              </tr>
            </thead>
            {importacaoVendaConsignatarioState.list.map((item: DetalhesImportacaoVendaConsignatarioDtoModel) => (
              <React.Fragment key={item.id}>
                <tbody className="body-table">
                  <tr>
                    <td className="ht-left">{item.consignatario}</td>
                    <td className="ht-left">{formatCPFCNPJ(item.cpfCnpjConsignatario)}</td>
                    <td className="ht-center">{formatNumber(item.quantidadeVenda)}</td>
                    <td className="ht-right">{currencyBRL(item.valorTicket)}</td>
                    <td className="ht-right">{currencyBRL(item.valorTotal)}</td>
                    <td className="ht-right">{formatNumber(item.vendaFisica_QuantidadeVendida)}</td>
                    <td className="ht-right">{currencyBRL(item.vendaFisica_ValorVenda)}</td>
                    <td className="ht-right">{formatNumber(item.vendaInternet_QuantidadeVendida)}</td>
                    <td className="ht-right">{currencyBRL(item.vendaInternet_ValorVenda)}</td>
                  </tr>
                </tbody>
              </React.Fragment>
            ))}
            <tfoot className="footer-table">
              <tr style={{ fontSize: "16px", fontWeight: "bold" }}>
                <td className="ht-left" colSpan={2}>
                  Total
                </td>
                <td className="ht-center">{formatNumber(totalQuantidadeVenda)}</td>
                <td className="ht-right" colSpan={2}>
                  {currencyBRL(totalValorTotal)}
                </td>
                <td className="ht-right">{formatNumber(totalVendaFisicaQuantidadeVendida)}</td>
                <td className="ht-right">{currencyBRL(totalVendaFisicaValorVenda)}</td>
                <td className="ht-right">{formatNumber(totalVendaInternetQuantidadeVendida)}</td>
                <td className="ht-right">{currencyBRL(totalVendaInternetValorVenda)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    );
  });

  const tabs = [
    {
      key: "1",
      label: "Informações das vendas",
      children: <TabelaListagem />,
      disabled: false,
    },
    {
      key: "2",
      label: "Visualização de impressão",
      children: <RelatorioHtml ref={relatorioImportacao} />,
      disabled: importacaoVendaConsignatarioState.list.length === 0,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical" form={form} onFinish={importarDados}>
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              {persistedState.user.empresa === null && (
                <Form.Item
                  label="Empresa"
                  name="idEmpresa"
                  rules={[
                    {
                      required: true,
                      message: "Campo obrigatório",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="labelSearch"
                    loading={empresaState.loading}
                    onChange={onChangeEmpresa}
                    style={{ width: 300 }}
                    options={empresaState.list.map((a: EmpresaModel) => ({
                      value: a.id,
                      key: a.apelido,
                      label: (
                        <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                          <Flex style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</Flex>
                          {a.apelido}
                        </Flex>
                      ),
                      labelSearch: a.apelido,
                    }))}
                  />
                </Form.Item>
              )}
              <Form.Item
                label="Data do sorteio"
                name="idSorteio"
                rules={[
                  {
                    required: true,
                    message: "Campo obrigatório",
                  },
                ]}
              >
                <Select
                  style={{ width: 150 }}
                  loading={sorteioState.loadingEmpresas}
                  options={sorteioState.listSorteioEmpresas.map((a: any) => ({
                    value: a.idSorteio,
                    label: dayjs(a.dataSorteio).format("DD/MM/YYYY"),
                  }))}
                  onChange={onChangeSorteio}
                />
              </Form.Item>
              <ButtonComponent htmlType="submit">IMPORTAR DADOS</ButtonComponent>
              <Form.Item label=" ">
                <Tooltip title="Atualizar">
                  <Button icon={<RedoOutlined />} className="buttonPrimary" onClick={atualizar} />
                </Tooltip>
              </Form.Item>
              <Form.Item label="Situação">
                <div className="situacaoTag">
                  {importacaoVendaConsignatarioState.list !== undefined ? (
                    <Tag color={importacaoVendaConsignatarioState.list[0]?.status === 1 ? "#5E993C" : "#FAAD14"} style={{ fontSize: "11px" }}>
                      {importacaoVendaConsignatarioState.list[0]?.status === 1 ? "PROCESSADO" : "NÃO PROCESSADO"}
                    </Tag>
                  ) : (
                    <Tag>NÃO IMPORTADO</Tag>
                  )}
                </div>
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex gap={12} justify="end">
              {abaAtiva === "2" && (
                <Form.Item name="botaoCarregar" label=" " style={{ marginRight: "10px" }}>
                  <Button icon={<PrinterOutlined />} onClick={handlePrint}></Button>
                </Form.Item>
              )}
              <ButtonComponent onClick={goConfirmarProcessar}>PROCESSAR DADOS</ButtonComponent>
            </Flex>
          </Col>
        </Row>
      </Form>

      <Tabs activeKey={abaAtiva} onChange={(key) => setAbaAtiva(key)} size="small">
        {tabs.map((tab) => (
          <TabPane tab={tab.label} key={tab.key} disabled={tab.disabled}>
            {tab.children}
          </TabPane>
        ))}
      </Tabs>
      <Modal title={"CONFIRMAR PROCESSAMENTO"} centered width={350} open={importacaoVendaConsignatarioState.modalConfirmar} onCancel={closeModalProcessar} footer={null} destroyOnHidden>
        <MensagemModal
          text="Tem certeza de que deseja confirmar o processamento dos dados da venda?"
          action={processarImportacaoVendaConsignatario(importacaoVendaConsignatarioState.busca)}
          close={setModalConfirmarImportacaoVendaConsignatario(false)}
        />
      </Modal>
    </Flex>
  );
};

export default ImportacaoVendaConsignatario;
